// LoginScreen.js (Web Version - ReactJS)
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const LoginScreen = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [ads, setAds] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const dist = sessionStorage.getItem("dist") || '320E';

  const fetchAds = () => {
    axios
      .post('https://lionsdirectoryapi.emedha.in/notification/api/advertise/get', {
        ad_page: 'login',
        dist,
      })
      .then((res) => setAds(res.data));
  };

  const handleLogin = async () => {
    try {
      const res = await axios.post('https://lionsdirectoryapi.emedha.in/login', {
        mobile,
        password,
        dist,
      });

      if (res.data === "Login Successful!...") {
        alert('Login Successful!');
        sessionStorage.setItem('loginEmail', mobile);
        sessionStorage.setItem('userToken', 'web_token');
        window.location.href = '/home';
      } else {
        alert('Please enter valid data..!');
      }
    } catch (error) {
      alert('Network error or invalid credentials.');
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  const previewContainerStyle = {
    width: '365px',
    minHeight: '557px',
    maxHeight: '667px',
    margin: '10px auto',
    border: '1px solid #ccc',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 0 10px rgba(0,0,0,0.2)',
    backgroundColor: '#f8f9fa',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  };

  return (
    <div style={previewContainerStyle}>
      <div className="login-header bg-primary text-white text-center p-2">
        <h5>Lions {dist}</h5>
      </div>

      <div className="login-body p-3" style={{ flexGrow: 1, overflowY: 'auto' }}>
        {ads.map((data) => (
          <img key={data.id} src={data.image} alt="ad" className="img-fluid mb-3" style={{ width: 360, height: 260 , resizeMode:'contain'}}/>
        ))}

        <Form>
          <Form.Group>
            <Form.Label>Mobile</Form.Label>
            <Form.Control
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Mobile"
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
            />
          </Form.Group>

          <Button className="mt-4 w-100" variant="primary" onClick={handleLogin}>
            Login
          </Button>

          <div className="text-center mt-3">
            <a href="/app/signup">Don't have an account? Signup</a>
          </div>

        </Form>
      </div>

      <Modal show={modalVisible} onHide={() => setModalVisible(false)} centered>
        <Modal.Body>
          <p className="text-center">
            Dear User, Kindly contact your district administration to reset password.
          </p>
          <div className="d-flex justify-content-center">
            <Button variant="secondary" onClick={() => setModalVisible(false)}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className="login-footer text-center bg-primary text-white p-2">
        @ 2025 Lions {dist} Club. All rights reserved.
      </div>
    </div>
  );
};

export default LoginScreen;
